import { useEffect } from "react";

const INDEX = "index, follow, max-image-preview:large, max-snippet:-1";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

/** Per-route title, description, robots and optional JSON-LD (rendered for crawlers by the platform prerender). */
export const Seo = ({ title, description, noindex = false, jsonLd }) => {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    document.title = title;
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("name", "robots", noindex ? "noindex, nofollow" : INDEX);
    if (!ld) return undefined;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = ld;
    document.head.appendChild(script);
    return () => script.remove();
  }, [title, description, noindex, ld]);

  return null;
};
